import React from 'react';

import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import store, { persistor } from 'store/storeConfig';
import { Loading } from 'components/Fetch';
import Init from 'init';
import IntlProviderWrapper from 'IntlProviderWrapper';
import { EpicProvider } from 'contexts/EpicContext';

// import packageJson from '../package.json';
import reportWebVitals from './reportWebVitals';

import 'styles/styles.scss';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-image-crop/dist/ReactCrop.css';
import 'react-toastify/dist/ReactToastify.css';

// if (import.meta.env.DEV === 'production' && import.meta.env.VITE_SENTRY_DSN) {
//   Sentry.init({
//     dsn: import.meta.env.VITE_SENTRY_DSN,
//     environment: window.location.host,
//     release: packageJson.version,
//     integrations: [
//       // new Sentry.BrowserTracing(),
//       new Sentry.Replay()
//     ],
//     // Performance Monitoring
//     tracesSampleRate: 0.1, // Capture 10% of the transactions
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//     ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured']
//   });
// }

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

root.render(
  <>
    <Provider store={store}>
      <HelmetProvider>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <IntlProviderWrapper>
            <EpicProvider>
              <Init />
            </EpicProvider>
          </IntlProviderWrapper>
        </PersistGate>
      </HelmetProvider>
    </Provider>
  </>
);

if (import.meta.env.VITE_SHOW_GIT_VERSION && import.meta.env.VITE_GIT_VERSION) {
  /* eslint-disable no-console */
  console.log('Git version: ' + import.meta.env.VITE_GIT_VERSION);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
